import React from 'react';
import type { SiteRagReport } from '../../../../types/siteRag';
import { SectionShell } from '../SectionShell';
import { useEffectiveReportTheme } from '../../../../lib/useEffectiveReportTheme';
import { EditorialSubsection } from '../../report/editorial';

export const CumulativeImpactsSection: React.FC<{ report: SiteRagReport; label: string }> = ({ report, label }) => {
  const theme = useEffectiveReportTheme();
  const data = report.cumulativeImpacts;
  const hasData = typeof data === 'string' && data.trim().length > 0;
  return (
    <SectionShell label={label} hasData={hasData}>
      {hasData && (
        <EditorialSubsection theme={theme} label="Cumulative Effects Screening">{data}</EditorialSubsection>
      )}
    </SectionShell>
  );
};
